/* Model */
class ServiceTimeTypeModel extends App.Models.BaseModel {
    modelUrl = 'ServiceTimeType';
}

App.Models.ServiceTimeType = ServiceTimeTypeModel;

/* Collection */
class ServiceTimeTypeCollection extends App.Collections.BaseCollection {
    url = 'ServiceTimeType';
    model = App.Models.ServiceTimeType;
}

App.Collections.ServiceTimeTypes = ServiceTimeTypeCollection;

/* Router */
class ServiceTimeTypeRouter extends App.Routers.BaseRouter {
    constructor() {
        const entityName = 'ServiceTimeType';
        const model = App.Models.ServiceTimeType;
        const collectionClass = App.Collections.ServiceTimeTypes;

        super(entityName, model, collectionClass);
    }

    onValidate = () => {
        const fields = App.Forms.ServiceTimeType.form.fields,
            fieldToValidate = ['nonHelperFixedTimeSecs', 'nonHelperVarTimeSecs', 'helperFixedTimeSecs', 'helperVarTimeSecs'];

        fieldToValidate.forEach((element) => {
            const field = fields[element];
            const value = field.getValue();

            field.rootEl.className = field.rootEl.className.replace('control-group error', '') ;

            if(!value && value !== 0 ) {
                this.allow_submit.errorMessages.push(
                    Monet.Form.Messages.mountErrorMessageObject(Monet.I18n.getResourcesByKey('general.mandatoryField', field.label.innerHTML))
                );
                field.rootEl.className += ' control-group error';
            }
        });

        if(this.allow_submit.errorMessages.length){
            this.allow_submit.status = false;
        }
    }

    afterCreateForm = (entity, formData, crudStage) => {
        const fields = App.Forms.ServiceTimeType.form.fields;
        if(crudStage === 'new') {
            const ZERO_SECONDS = 0;

            fields.nonHelperFixedTimeSecs.setValue(ZERO_SECONDS);
            fields.nonHelperVarTimeSecs.setValue(ZERO_SECONDS);
            fields.helperFixedTimeSecs.setValue(ZERO_SECONDS);
            fields.helperVarTimeSecs.setValue(ZERO_SECONDS);
        }
    }
}

App.Routers.ServiceTimeType = ServiceTimeTypeRouter;
